import './PartyPackageMenu.css';
import React, { useState, useMemo } from 'react';
import { RiCheckboxBlankCircleLine } from "react-icons/ri";
import { API_BASE_URL } from '../../utils';
import { fi } from 'date-fns/locale';

export default function ClubMenuCards({ menus = [] }) {
    const [selectedCategory, setSelectedCategory] = useState('All');

    const menuData = menus.length > 0 ? menus[0].category : {};

    const categories = useMemo(() => {
        const validCategories = Object.entries(menuData)
            .filter(([key, items]) => {
                const choice = items?.veg_choice || items?.nonveg_choice || items?.item_choice;
                return key !== 'clubLogo' && key !== 'category' && choice !== "0";
            })
            .map(([key]) => key);
        return ['All', ...validCategories];
    }, [menuData]);

    const filteredMenus = useMemo(() => {
        const entries = Object.entries(menuData).filter(([key, items]) => {
            const choice = items?.veg_choice || items?.nonveg_choice || items?.item_choice;
            return key !== 'clubLogo' && key !== 'category' && choice !== "0";
        });

        if (selectedCategory === 'All') return entries;
        return entries.filter(([key]) => key === selectedCategory);
    }, [selectedCategory, menuData]);



    return (
        <div className="cmc-gallery-empty-container">
            {!menus || menus.length === 0 || !menus[0]?.category || filteredMenus.length === 0 ? (
                <div className="cmc-gallery-empty-content">
                    <h1>No Menu Cards Available</h1>
                    <p>We’re working on an exciting menu to give you the best value and experience.</p>
                    <img
                        src="https://illustrations.popsy.co/gray/web-design.svg"
                        alt="Coming Soon"
                        className="cmc-gallery-empty-image"
                    />
                </div>
            ) : (
                <div className="cmc-gallery-container">

                    <div className="cmc-gallery-filters">
                        {categories.map((cat, i) => (
                            <span
                                key={i}
                                className={`cmc-filter-button ${selectedCategory === cat ? 'cmc-active' : ''}`}
                                onClick={() => setSelectedCategory(cat)}
                            >
                                {cat.replace(/_/g, ' ').toUpperCase()}
                            </span>
                        ))}
                    </div>

                    <div className="cmc-gallery-content">
                        {filteredMenus.map(([category, items], index) => {
                            const sectionId = `preview-${category}-${index}`; // Unique ID

                            // Extract individual choice counts
                            const vegChoice = items?.veg_choice ? Number(items.veg_choice) : 0;
                            const nonVegChoice = items?.nonveg_choice ? Number(items.nonveg_choice) : 0;
                            const itemChoice = items?.item_choice ? Number(items.item_choice) : 0;

                            const choiceLabels = [];
                            if (vegChoice) choiceLabels.push(`Veg: ${vegChoice}`);
                            if (nonVegChoice) choiceLabels.push(`Non-Veg: ${nonVegChoice}`);
                            if (itemChoice) choiceLabels.push(`Item: ${itemChoice}`);

                            return (
                                <div key={index} className="cmc-preview-wrapper">
                                    {/* ✅ Normal Mode Display */}
                                    <a
                                        data-fancybox
                                        data-src={`#${sectionId}`}
                                        href="javascript:void(0);"
                                        className="cmc-preview-button"
                                        title="Preview"
                                    >
                                        <div className="cmc-gallery-card-section">
                                            <div className="cmc-gallery-header">
                                                <h2 className="cmc-gallery-title">
                                                    {category.replace(/_/g, ' ').toUpperCase()} ({choiceLabels.join(', ')})
                                                </h2>
                                            </div>

                                            <div className="cmc-gallery-content-section">
                                                <div className='cmc-items-list'>
                                                    {items?.veg?.map((item, i) => item && (
                                                        <span key={`veg-${i}`}>
                                                            <div className='cmc-veg-logo-veg'>
                                                                <RiCheckboxBlankCircleLine color='green' />
                                                            </div>
                                                            {item}
                                                        </span>
                                                    ))}
                                                </div>

                                                <div className='cmc-items-list'>
                                                    {items?.nonveg?.map((item, i) => item && (
                                                        <span key={`nonveg-${i}`}>
                                                            <div className='cmc-veg-logo-non-veg'>
                                                                <RiCheckboxBlankCircleLine color='red' />
                                                            </div>
                                                            {item}
                                                        </span>
                                                    ))}
                                                </div>

                                                <div className='cmc-items-list'>
                                                    {!items?.veg && !items?.nonveg && items?.item?.map((item, i) => item && (
                                                        <span key={`item-${i}`}>🍽 {item}</span>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </a>

                                    {/* ✅ Hidden Preview Mode Content */}
                                    <div id={sectionId} style={{ display: 'none', maxWidth: '500px' }}>
                                        <div className="cmc-gallery-card-section">
                                            <h2 className="cmc-gallery-title">
                                                {category.replace(/_/g, ' ').toUpperCase()} ({choiceLabels.join(', ')})
                                            </h2>
                                            <div className="cmc-gallery-content-section">
                                                <div className='cmc-items-list'>
                                                    {items?.veg?.map((item, i) => item && (
                                                        <span key={`veg-preview-${i}`}>
                                                            <div className='cmc-veg-logo-veg'>
                                                                <RiCheckboxBlankCircleLine color='green' />
                                                            </div>
                                                            {item}
                                                        </span>
                                                    ))}
                                                </div>
                                                <div className='cmc-items-list'>
                                                    {items?.nonveg?.map((item, i) => item && (
                                                        <span key={`nonveg-preview-${i}`}>
                                                            <div className='cmc-veg-logo-non-veg'>
                                                                <RiCheckboxBlankCircleLine color='red' />
                                                            </div>
                                                            {item}
                                                        </span>
                                                    ))}
                                                </div>
                                                <div className='cmc-items-list'>
                                                    {!items?.veg && !items?.nonveg && items?.item?.map((item, i) => item && (
                                                        <span key={`item-preview-${i}`}>🍽 {item}</span>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}


                    </div>
                </div>
            )
            }
        </div >
    );
}



